
import {timeIsValid} from 'helpers/date'
import {spaceship} from 'helpers/sort'
import BasePerson from 'models/BasePerson'

export default class DailyPerson extends BasePerson {

  // アクセサ: 検索用キー値を取得
  static key(storeCode, floorCode, personCode, date) {
    if(storeCode instanceof Object) {
      floorCode  = storeCode.floor_code
      personCode = storeCode.person_code
      date       = storeCode.date
      storeCode  = storeCode.store_code
    }
    return storeCode + '/' + floorCode + '/' + personCode + '/' + date
  }

  // アクセサ: 勤務時刻の表示用文字列
  get timeLabel() {
    return this.constructor.makeTimeLabel(this.begin_time, this.end_time)
  }

  // アクセサ: 勤務時刻のバリデーション
  get isTimeValid() {
    return timeIsValid(this.begin_time, this.end_time)
  }

  // アクセサ: 通常勤務時刻のバリデーション
  get isRegularTimeValid() {
    return timeIsValid(this.regular_begin_time, this.regular_end_time)
  }

  // 配列処理: 並び順でソート (レジシフト画面用)
  static sortForShifts(people) {
    return Object.values(people).sort((a, b) =>
      spaceship(b.isTimeValid,  a.isTimeValid ) ||
      spaceship(a.group,        b.group       ) ||
      spaceship(a.begin_time,   b.begin_time  ) ||
      spaceship(a.order,        b.order       ) ||
      spaceship(a.person_code,  b.person_code )
    )
  }
}
